import { all, fork } from 'redux-saga/effects';
import { watchLogin, watchChangePassword, watchSetVignetNumber } from './auth';
import { watchSaveUser, watchFetchUser, watchUpdateUser } from './user';
import { watchFetchObject, watchFetchBoatTypes, watchFetchJettyTypes, watchFetchDriveTypes, watchUpdateObject } from './object';
import { watchUploadDocument, } from './document';
import { watchFetchCosts, } from './costs';
import { watchFetchGeojsonData } from './map';
import { watchUploadImage, } from './image';

export default function* rootSaga() {
  yield all([
    watchLogin(),
    watchChangePassword(),
    watchSetVignetNumber(),
    watchSaveUser(),
    watchFetchUser(),
    watchUpdateUser(),
    watchFetchObject(),
    watchFetchBoatTypes(),
    watchFetchJettyTypes(),
    watchFetchDriveTypes(),
    watchUpdateObject(),
    watchUploadDocument(),
    watchFetchCosts(),
    watchFetchGeojsonData(),
    watchUploadImage(),
  ]);
}
